"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), {}, {
    children: (0, _jsxRuntime.jsx)("path", {
      d: "M15.999 4C9.373 4 4 9.509 4 16.304c0 5.436 3.438 10.047 8.207 11.674.6.113.819-.266.819-.593 0-.291-.01-1.065-.017-2.092-3.337.743-4.042-1.65-4.042-1.65-.546-1.421-1.332-1.8-1.332-1.8-1.09-.762.082-.747.082-.747 1.205.087 1.838 1.268 1.838 1.268 1.07 1.88 2.81 1.337 3.493 1.022.109-.795.419-1.337.762-1.644-2.665-.31-5.467-1.367-5.467-6.081 0-1.343.468-2.442 1.236-3.302-.124-.311-.536-1.563.118-3.256 0 0 1.007-.33 3.3 1.261A11.18 11.18 0 0116 9.95c1.02.005 2.046.14 3.005.414 2.29-1.592 3.296-1.261 3.296-1.261.655 1.693.243 2.945.12 3.256.77.86 1.233 1.959 1.233 3.302 0 4.726-2.806 5.766-5.478 6.07.43.38.814 1.131.814 2.28 0 1.644-.015 2.97-.015 3.374 0 .33.217.713.825.592 4.765-1.63 8.2-6.238 8.2-11.673C28 9.51 22.627 4 15.999 4",
      fill: "#161514",
      fillRule: "evenodd"
    })
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Github.js.map